import type { HelpTopicPair } from "../types";

const topic: HelpTopicPair = {
  th: {
    id: "users",
    title: "ผู้ใช้",
    summary:
      "รายชื่อบัญชีผู้ใช้ทั้งหมดในระบบ ใช้ค้นหา กรอง เรียงลำดับ ส่งออกเป็นไฟล์ CSV และเพิ่มผู้ใช้ใหม่ กดที่แถวใดก็ได้เพื่อเปิดหน้ารายละเอียดของผู้ใช้คนนั้น",
    access:
      'ต้องมีสิทธิ์อ่านข้อมูลผู้ใช้ (owner, admin, auditor) จึงเห็นหน้านี้ ปุ่ม "เพิ่มผู้ใช้" แสดงเฉพาะผู้ที่มีสิทธิ์แก้ไขผู้ใช้ (owner, admin) การกำหนดบทบาทและกลุ่มในหน้าต่างเพิ่มผู้ใช้ต้องมีสิทธิ์แก้ไขบทบาทและกลุ่มตามลำดับ',
    shot: {
      file: "users-list.png",
      caption: 'หน้า "ผู้ใช้": แถบเครื่องมือด้านบน ตารางผู้ใช้ และตัวเปลี่ยนหน้าด้านล่าง',
    },
    sections: [
      {
        id: "open",
        heading: "เปิดหน้ารายชื่อผู้ใช้",
        body: [
          'กดเมนู "ผู้ใช้" ในหมวด "การยืนยันตัวตน" ที่แถบเมนูด้านซ้าย หรือแท็บ "ผู้ใช้" ที่แถวแท็บด้านบน ตารางเรียงผู้ใช้ที่สร้างล่าสุดไว้บนสุดเป็นค่าเริ่มต้น',
          'กดที่แถวของผู้ใช้ (ส่วนใดก็ได้ยกเว้นช่องติ๊ก) เพื่อเปิดหน้ารายละเอียด ซึ่งใช้แก้ไขโปรไฟล์ จัดการรหัสผ่าน สิทธิ์ และอื่น ๆ (ดูคู่มือ "รายละเอียดผู้ใช้")',
        ],
      },
      {
        id: "columns",
        heading: "คอลัมน์ในตาราง",
        body: [
          'คอลัมน์ที่มีเครื่องหมาย (ซ่อนไว้) จะไม่แสดงตอนเริ่มต้น เปิดได้จากปุ่ม "คอลัมน์" ในแถบเครื่องมือ',
        ],
        fieldsTitle: "คอลัมน์",
        fields: [
          {
            name: "ผู้ใช้",
            description:
              'รูปโปรไฟล์ (หรือตัวย่อชื่อ) อีเมลหลักของบัญชี และบรรทัดล่างเป็นชื่อที่แสดง ถ้าผู้ใช้มีรหัสผู้ใช้งานหรือชื่อผู้ใช้ จะแสดงนำหน้าชื่อเป็น รหัส · @ชื่อผู้ใช้ · ชื่อที่แสดง (เช่น pc-00123 · @somchai.k · สมชาย ใจดี) บัญชีระบบ root แสดงคำว่า root พร้อมป้ายสีส้ม "root" คอลัมน์นี้ซ่อนไม่ได้ และเรียงตามอีเมลได้',
          },
          {
            name: "ชื่อที่แสดง (ซ่อนไว้)",
            description: "ชื่อที่แสดงของผู้ใช้แยกเป็นคอลัมน์ เปิดไว้เมื่อต้องการเรียงตามชื่อ",
          },
          {
            name: "ผู้ให้บริการ",
            description:
              'วิธีเข้าสู่ระบบที่บัญชีผูกไว้ "อีเมล/รหัสผ่าน" หมายถึงยังไม่ได้ผูกบัญชีภายนอก ถ้าผูกแล้วจะแสดงชื่อผู้ให้บริการ เช่น google หรือ microsoft',
          },
          {
            name: "สร้างเมื่อ",
            description: "วันที่สร้างบัญชี เรียงลำดับได้ (ค่าเริ่มต้นคือใหม่สุดก่อน)",
          },
          {
            name: "เข้าสู่ระบบล่าสุด",
            description: 'วันและเวลาที่เข้าสู่ระบบสำเร็จครั้งล่าสุด ถ้ายังไม่เคยเข้าเลยจะแสดง "ไม่เคย"',
          },
          {
            name: "สถานะ",
            description:
              '"ใช้งาน" (สีเขียว) = ยืนยันอีเมลแล้วและใช้งานได้ปกติ · "รอยืนยัน" (สีเหลือง) = ยังไม่ได้ยืนยันอีเมล เช่น ได้รับอีเมลเชิญแต่ยังไม่ได้ตั้งรหัสผ่าน · "ถูกระงับ" (สีแดง) = ผู้ดูแลระงับบัญชี เข้าสู่ระบบไม่ได้',
          },
          {
            name: "MFA",
            description:
              '"เปิด MFA" = ผู้ใช้ตั้งค่าการยืนยันตัวตนสองขั้นตอนแล้ว · "ไม่เปิด MFA" = ยังไม่ได้ตั้งค่า',
          },
          {
            name: "บทบาท",
            description: "บทบาทคอนโซลของผู้ใช้ (เช่น owner, admin, auditor) ผู้ใช้ส่วนใหญ่ไม่มีบทบาท",
          },
          {
            name: "ประเภทผู้ใช้",
            description:
              'ประเภทของบัญชี เช่น employee (สีน้ำเงิน) customer หรือ partner บัญชี root แสดงเป็น "บัญชีระบบ" เพราะไม่มีประเภท',
          },
          {
            name: "กลุ่ม (ซ่อนไว้)",
            description: "รหัสของกลุ่มที่ผู้ใช้เป็นสมาชิก",
          },
          {
            name: "รหัสผู้ใช้ (ซ่อนไว้)",
            description:
              "รหัสประจำบัญชีแบบยาว (UUID) ที่ไม่เปลี่ยนตลอดอายุบัญชี และเป็นรหัสที่แอปพลิเคชันต่าง ๆ ได้รับ ใช้เทียบกับรหัสในบันทึกการใช้งาน",
          },
        ],
        tips: [
          'อย่าสับสนระหว่าง "รหัสผู้ใช้" (User ID — รหัสยาวที่ระบบสร้างให้ เช่น 0192f6c3-…) กับ "รหัสผู้ใช้งาน" (User code — รหัสสั้นที่องค์กรออกให้ เช่น รหัสพนักงาน) และ "ชื่อผู้ใช้" (Username — ชื่อที่ผู้ใช้ตั้งเอง เช่น somchai.k) สองอย่างหลังพิมพ์แทนอีเมลตอนเข้าสู่ระบบได้',
        ],
      },
      {
        id: "search",
        heading: "ค้นหาผู้ใช้",
        body: [
          'พิมพ์คำค้นในช่อง "ค้นหา…" บนแถบเครื่องมือ ตารางจะกรองทันทีที่พิมพ์ คำค้นจับคู่กับอีเมลหลัก อีเมลเพิ่มเติม เบอร์โทรศัพท์ รหัสผู้ใช้งาน ชื่อผู้ใช้ ชื่อ รหัสผู้ใช้ (User ID) รหัสพนักงาน และแผนก',
          'กดปุ่ม ✕ ในช่องค้นหา ("ล้างคำค้นหา") เพื่อแสดงทุกคนอีกครั้ง',
        ],
        tips: [
          "ค้นหาด้วยส่วนหนึ่งของคำได้ เช่น พิมพ์ชื่อโดเมน @company.co.th เพื่อหาทุกคนที่ใช้อีเมลบริษัท",
          "เมื่อเปลี่ยนคำค้นหรือตัวกรอง ตารางจะกลับไปหน้าแรกเสมอ",
        ],
      },
      {
        id: "filters",
        heading: "กรองรายชื่อ",
        body: [
          'กดปุ่ม "ตัวกรอง" บนแถบเครื่องมือเพื่อเปิดแผงตัวกรอง แต่ละแถวของตัวกรองมี "คอลัมน์" "เงื่อนไข" และ "ค่า" กด "เพิ่มตัวกรอง" เพื่อเพิ่มแถว ไอคอนถังขยะ ("ลบตัวกรอง") เพื่อลบแถวนั้น หรือ "ลบทั้งหมด" เพื่อล้างทุกตัวกรอง',
          'เมื่อมีหลายตัวกรอง ผู้ใช้ต้องตรงทุกเงื่อนไข (และ) ตัวเลขบนปุ่ม "ตัวกรอง" บอกจำนวนตัวกรองที่ใช้อยู่',
        ],
        shot: {
          file: "users-filters.png",
          caption: 'แผงตัวกรอง: ตัวอย่างกรองผู้ใช้ที่มีสถานะ "ใช้งาน"',
        },
        fieldsTitle: "คอลัมน์ที่กรองได้",
        fields: [
          { name: "สถานะ", description: 'เลือก "ใช้งาน" "รอยืนยัน" หรือ "ถูกระงับ"' },
          {
            name: "MFA",
            description: '"ใช่" = เฉพาะคนที่เปิด MFA · "ไม่ใช่" = เฉพาะคนที่ยังไม่เปิด · "ทั้งหมด" = ไม่กรอง',
          },
          {
            name: "บทบาท",
            description: "เลือกบทบาท เช่น admin เพื่อดูว่าใครมีบทบาทนี้บ้าง (ต้องมีสิทธิ์อ่านบทบาท)",
          },
          {
            name: "ประเภทผู้ใช้",
            description: "เลือกประเภท เช่น employee หรือ customer (บัญชี root ไม่อยู่ในประเภทใด)",
          },
          {
            name: "กลุ่ม",
            description: "เลือกกลุ่มเพื่อดูสมาชิกของกลุ่มนั้น (ต้องมีสิทธิ์อ่านกลุ่ม)",
          },
        ],
        tips: [
          'กดเมนูของหัวคอลัมน์ (ไอคอนจุดสามจุดที่หัวคอลัมน์) แล้วเลือก "กรอง" เพื่อเพิ่มตัวกรองของคอลัมน์นั้นได้เร็วขึ้น',
          "ตัวอย่างการใช้งาน: หาผู้ดูแลที่ยังไม่เปิด 2FA ให้กรอง บทบาท = admin และ MFA = ไม่ใช่",
        ],
      },
      {
        id: "sort",
        heading: "เรียงลำดับ",
        body: [
          'กดที่หัวคอลัมน์ "ผู้ใช้" (เรียงตามอีเมล) "ชื่อที่แสดง" หรือ "สร้างเมื่อ" เพื่อเรียงลำดับ กดซ้ำเพื่อสลับน้อยไปมาก / มากไปน้อย หรือใช้เมนูหัวคอลัมน์ "เรียงจากน้อยไปมาก" "เรียงจากมากไปน้อย" "ยกเลิกการเรียง"',
          "คอลัมน์อื่นเรียงลำดับไม่ได้ เมื่อยกเลิกการเรียง ตารางจะกลับไปเรียงผู้ใช้ใหม่สุดก่อน",
        ],
      },
      {
        id: "paging",
        heading: "เปลี่ยนหน้าและจำนวนแถว",
        body: [
          'ด้านล่างตารางแสดงช่วงที่กำลังดู เช่น "1–25 จาก 240" เลือก "แถวต่อหน้า" ได้ 25, 50 หรือ 100 (ระบบจำค่าที่เลือกไว้ในเบราว์เซอร์) ใช้ปุ่ม "หน้าแรก" "หน้าก่อน" และ "หน้าถัดไป" เพื่อเลื่อนหน้า',
          "ไม่มีปุ่มกระโดดไปหน้าสุดท้าย ถ้าต้องการหาคนที่ต้องการเร็ว ๆ ให้ใช้การค้นหาหรือตัวกรองแทน",
        ],
      },
      {
        id: "layout",
        heading: "ซ่อน/แสดงคอลัมน์ ความหนาแน่น และการจัดตาราง",
        body: [
          'ปุ่ม "คอลัมน์" เปิดรายการคอลัมน์ทั้งหมด ติ๊กเพื่อแสดง เอาติ๊กออกเพื่อซ่อน มีช่อง "ค้นหาคอลัมน์" ปุ่ม "แสดงทั้งหมด" "ซ่อนทั้งหมด" และ "คืนค่าเริ่มต้น" (กลับไปใช้การจัดตารางแบบเดิม)',
          'ปุ่ม "ความหนาแน่น" เลือกระยะห่างของแถว: "กะทัดรัด" "มาตรฐาน" หรือ "โปร่ง"',
          'เมนูหัวคอลัมน์มีคำสั่ง "ซ่อนคอลัมน์" "จัดการคอลัมน์" "ปักหมุดซ้าย" "ปักหมุดขวา" (ให้คอลัมน์ค้างไว้เมื่อเลื่อนตารางแนวนอน) และลากขอบหัวคอลัมน์เพื่อปรับความกว้างได้',
          "การจัดตารางทั้งหมด (คอลัมน์ที่แสดง ความกว้าง หมุด ความหนาแน่น) ถูกจำไว้ในเบราว์เซอร์ของคุณเท่านั้น ไม่กระทบผู้ใช้คนอื่น",
        ],
        shot: {
          file: "users-columns.png",
          caption: 'แผง "คอลัมน์": เลือกคอลัมน์ที่ต้องการแสดง',
        },
      },
      {
        id: "export",
        heading: "ส่งออกเป็นไฟล์ CSV",
        body: [
          'ปุ่ม "ส่งออก" บนแถบเครื่องมือมีสองแบบ: "ดาวน์โหลดเป็น CSV" ส่งออกผู้ใช้ทุกคนที่ตรงกับคำค้นและตัวกรองปัจจุบัน (ทุกหน้า สูงสุด 5,000 คน) และ "ดาวน์โหลด N แถวที่เลือกเป็น CSV" ซึ่งแสดงเมื่อคุณติ๊กเลือกแถวไว้',
          'ติ๊กช่องหน้าแถวเพื่อเลือกผู้ใช้ทีละคน หรือช่องที่หัวตาราง ("เลือกทุกแถว") เพื่อเลือกทุกคนในหน้านั้น ไฟล์ CSV เปิดด้วย Excel หรือ Google Sheets ได้',
        ],
        shot: {
          file: "users-export-menu.png",
          caption: 'เมนู "ส่งออก" หลังเลือกผู้ใช้ 2 คน',
        },
        warnings: [
          "ไฟล์ที่ส่งออกมีข้อมูลส่วนบุคคล (อีเมล ชื่อ ฯลฯ) ต้องเก็บรักษาตามนโยบาย PDPA ขององค์กร และลบเมื่อไม่ใช้แล้ว อย่าส่งต่อทางช่องทางที่ไม่ปลอดภัย",
        ],
      },
      {
        id: "add",
        heading: "เพิ่มผู้ใช้ใหม่",
        body: [
          'กดปุ่ม "เพิ่มผู้ใช้" ที่มุมขวาของแถบเครื่องมือ (หรือปุ่มเดียวกันในตารางว่างเมื่อยังไม่มีผู้ใช้) จะเปิดหน้าต่าง "เพิ่มผู้ใช้"',
        ],
        shot: {
          file: "users-add-dialog.png",
          caption: 'หน้าต่าง "เพิ่มผู้ใช้"',
        },
        fieldsTitle: "ช่องในหน้าต่างเพิ่มผู้ใช้",
        fields: [
          {
            name: "อีเมล",
            required: true,
            description:
              "อีเมลหลักของบัญชี ต้องเป็นรูปแบบอีเมลที่ถูกต้อง ยาวไม่เกิน 254 ตัวอักษร และต้องไม่ซ้ำกับอีเมลหลักหรืออีเมลเพิ่มเติมของคนอื่นในระบบ เป็นอีเมลที่แอปพลิเคชันต่าง ๆ จะได้รับ และเป็นที่รับอีเมลเชิญ",
          },
          {
            name: "ชื่อที่แสดง",
            required: true,
            description: "ชื่อที่แสดงในระบบและในแอปพลิเคชัน เช่น สมชาย ใจดี ยาวไม่เกิน 200 ตัวอักษร",
          },
          {
            name: "รหัสผู้ใช้งาน (ไม่บังคับ)",
            description:
              'รหัสสั้นที่ใช้เข้าสู่ระบบแทนอีเมลได้ (เช่น รหัสพนักงาน) 3–32 ตัว: ตัวอักษรภาษาอังกฤษ ตัวเลข . _ - ขึ้นต้นด้วยตัวอักษรหรือตัวเลข ตัวพิมพ์ใหญ่จะถูกเก็บเป็นตัวพิมพ์เล็ก (PC-00123 → pc-00123) ใช้ตัวเลขล้วนได้ แต่ห้ามเป็นตัวเลข 9 หลักขึ้นไปเพราะจะสับสนกับเบอร์โทร ต้องไม่ซ้ำกับรหัสผู้ใช้งานหรือชื่อผู้ใช้ของใคร ถ้าซ้ำจะขึ้น "รหัสผู้ใช้งานนี้มีคนใช้แล้ว"',
          },
          {
            name: "ชื่อผู้ใช้ (ไม่บังคับ)",
            description:
              'ชื่อสำหรับเข้าสู่ระบบอีกชื่อหนึ่ง ที่ผู้ใช้อยากใช้เอง (เช่น somchai.k) ใช้แทนอีเมลได้เหมือนรหัสผู้ใช้งาน กติกาเหมือนรหัสผู้ใช้งานทุกข้อ ใส่ได้ทั้งสองช่องหรือช่องเดียวก็ได้ ค่าเดียวกันจะเป็นทั้งรหัสผู้ใช้งานและชื่อผู้ใช้ไม่ได้ (ทั้งของคนเดียวกันและคนละคน) ถ้าซ้ำจะขึ้น "ชื่อผู้ใช้นี้มีคนใช้แล้ว"',
          },
          {
            name: "ประเภทผู้ใช้",
            description:
              "ค่าเริ่มต้นคือ employee (พนักงาน) เลือกประเภทอื่นได้ เช่น customer หรือ partner ประเภทผู้ใช้กำหนดว่าบัญชีเข้าแอปพลิเคชันใดได้ และกลุ่มเริ่มต้นที่จะได้ บทบาทคอนโซลให้ได้เฉพาะ employee",
          },
          {
            name: "กลุ่ม",
            description:
              'เลือกได้หลายกลุ่ม (พิมพ์เพื่อค้นหาในรายการ) แสดงเฉพาะผู้ที่มีสิทธิ์แก้ไขกลุ่ม นอกจากกลุ่มที่เลือก ผู้ใช้จะถูกเพิ่มเข้า "กลุ่มเริ่มต้น" ของประเภทผู้ใช้นั้นโดยอัตโนมัติเสมอ',
          },
          {
            name: "บทบาท",
            description:
              'ติ๊กบทบาทคอนโซลที่ต้องการให้ แสดงเฉพาะเมื่อคุณมีสิทธิ์แก้ไขบทบาทและเลือกประเภท employee (ถ้าเลือกประเภทอื่นจะเห็นข้อความ "บทบาทคอนโซลให้ได้เฉพาะ employee เท่านั้น") บทบาท owner แสดงเฉพาะเมื่อคุณเป็น owner ปล่อยว่างได้ ผู้ใช้ส่วนใหญ่ไม่ต้องมีบทบาท',
          },
          {
            name: "ส่งอีเมลเชิญให้ผู้ใช้ตั้งรหัสผ่าน",
            description:
              "ติ๊กไว้เป็นค่าเริ่มต้น ระบบจะส่งอีเมลเชิญพร้อมลิงก์ให้ผู้ใช้ตั้งรหัสผ่านเอง ลิงก์ใช้ได้ 24 ชั่วโมง",
          },
        ],
        steps: [
          'กดปุ่ม "เพิ่มผู้ใช้"',
          'กรอก "อีเมล" และ "ชื่อที่แสดง" (ช่องบังคับ)',
          'ถ้าต้องการ ใส่ "รหัสผู้ใช้งาน" เช่น รหัสพนักงาน และ/หรือ "ชื่อผู้ใช้" ที่ผู้ใช้อยากใช้เข้าสู่ระบบ',
          'เลือก "ประเภทผู้ใช้" (พนักงานใช้ employee) และกลุ่มที่ต้องการ',
          "ถ้าผู้ใช้คนนี้ต้องดูแลระบบ ให้ติ๊กบทบาท เช่น admin หรือ auditor",
          'เลือกว่าจะส่งอีเมลเชิญหรือไม่ แล้วกดปุ่ม "เพิ่มผู้ใช้" ที่ด้านล่างหน้าต่าง (หรือ "ยกเลิก" เพื่อปิดโดยไม่บันทึก)',
        ],
        tips: ["ถ้ากรอกไม่ถูกต้อง ข้อความผิดพลาดจะแสดงใต้ช่องนั้น และหน้าต่างจะยังเปิดอยู่ให้แก้ไข"],
      },
      {
        id: "after-add",
        heading: "หลังจากเพิ่มผู้ใช้",
        body: [
          'เมื่อสร้างสำเร็จ จะเห็นข้อความ "สร้างผู้ใช้แล้ว" และระบบเปิดหน้ารายละเอียดของผู้ใช้ใหม่ให้ทันที เพื่อเพิ่มข้อมูลโปรไฟล์ เบอร์โทร หรือสิทธิ์อื่น ๆ ต่อได้',
          'ถ้าติ๊กส่งอีเมลเชิญ: ผู้ใช้จะได้รับอีเมลพร้อมลิงก์ตั้งรหัสผ่าน (ใช้ได้ 24 ชั่วโมง) สถานะจะเป็น "รอยืนยัน" จนกว่าผู้ใช้จะกดลิงก์และตั้งรหัสผ่าน แล้วจะเปลี่ยนเป็น "ใช้งาน" เพราะการกดลิงก์ในอีเมลถือเป็นการยืนยันอีเมลไปด้วย',
          'ถ้าไม่ได้ส่งอีเมลเชิญ: บัญชียังไม่มีรหัสผ่าน ผู้ใช้เข้าสู่ระบบด้วยรหัสผ่านไม่ได้จนกว่าคุณจะใช้ปุ่ม "ตั้งรหัสผ่านใหม่" หรือ "ส่งลิงก์ตั้งรหัสผ่านใหม่" ในแท็บ "ความปลอดภัย" หรือผู้ใช้กด "ลืมรหัสผ่าน" เองที่หน้าเข้าสู่ระบบ (หรือเข้าด้วย Google / Microsoft ถ้าเปิดไว้และอีเมลตรงกัน)',
          "การสร้างผู้ใช้ทุกครั้งถูกบันทึกในบันทึกการใช้งาน (user.created)",
        ],
        tips: [
          'ถ้าผู้ใช้ไม่ได้รับอีเมลเชิญ หรือลิงก์หมดอายุ ให้เปิดหน้ารายละเอียดผู้ใช้ แท็บ "ความปลอดภัย" แล้วกด "ส่งลิงก์ตั้งรหัสผ่านใหม่" (ลิงก์นี้ใช้ได้ 1 ชั่วโมง) หรือกด "ตั้งรหัสผ่านใหม่" แล้วแจ้งรหัสให้ผู้ใช้ทางช่องทางส่วนตัว',
        ],
        warnings: [
          "ถ้าขึ้นข้อผิดพลาดว่าอีเมลถูกใช้แล้ว แปลว่ามีบัญชีที่ใช้อีเมลนี้อยู่แล้ว (เป็นอีเมลหลักหรืออีเมลเพิ่มเติมของใครสักคน) ให้ค้นหาอีเมลนั้นในหน้ารายชื่อก่อน อย่าสร้างบัญชีซ้ำ",
        ],
      },
      {
        id: "reload",
        heading: "โหลดข้อมูลใหม่",
        body: [
          'กดไอคอนลูกศรวน ("โหลดใหม่") ข้างปุ่ม "เพิ่มผู้ใช้" เพื่อดึงข้อมูลล่าสุดจากเซิร์ฟเวอร์ เช่น เมื่อผู้ดูแลคนอื่นเพิ่งแก้ไขผู้ใช้ หรือผู้ใช้เพิ่งตั้งรหัสผ่านจากอีเมลเชิญ',
        ],
      },
    ],
    related: ["user-detail", "groups", "roles", "user-types"],
  },
  en: {
    id: "users",
    title: "Users",
    summary:
      "The list of every user account. Search, filter, sort, export to CSV and add new users. Click any row to open that user's detail page.",
    access:
      'You need permission to read users (owner, admin, auditor) to see this page. The "Add user" button is shown only to people who may change users (owner, admin). Setting roles and groups in the Add user dialog also needs permission to change roles and groups respectively.',
    shot: {
      file: "users-list.png",
      caption: 'The "Users" page: toolbar at the top, the users table and the page controls at the bottom',
    },
    sections: [
      {
        id: "open",
        heading: "Opening the user list",
        body: [
          'Click "Users" in the "Authentication" section of the navigator, or the "Users" tab in the tabs row. By default the newest users are at the top.',
          'Click a user\'s row (anywhere except the checkbox) to open the detail page, where you edit the profile, manage passwords, access and more (see the "User details" manual).',
        ],
      },
      {
        id: "columns",
        heading: "Columns in the table",
        body: [
          'Columns marked (hidden) are not shown at first; turn them on with the "Columns" toolbar button.',
        ],
        fieldsTitle: "Columns",
        fields: [
          {
            name: "Identifier",
            description:
              'Picture (or initials), the account\'s primary email and, below it, the display name. If the user has a user code or username they appear before the name as code · @username · display name (e.g. pc-00123 · @somchai.k · Somchai Jaidee). The root system account shows "root" with an orange "root" badge. This column cannot be hidden; sorting it sorts by email.',
          },
          {
            name: "Display name (hidden)",
            description: "The display name as its own column — turn it on to sort by name.",
          },
          {
            name: "Providers",
            description:
              'How the account signs in. "Email/password" means no external account is linked; otherwise the provider names, e.g. google or microsoft.',
          },
          { name: "Created", description: "When the account was created. Sortable (default: newest first)." },
          {
            name: "Signed in",
            description: 'Date and time of the last successful sign-in, or "Never".',
          },
          {
            name: "Status",
            description:
              '"Active" (green) = email verified, works normally · "Pending" (yellow) = email not verified yet, e.g. invited but no password set · "Banned" (red) = blocked by an administrator, cannot sign in.',
          },
          {
            name: "MFA",
            description: '"MFA on" = two-factor authentication is set up · "MFA off" = not set up.',
          },
          {
            name: "Roles",
            description: "The user's console roles (e.g. owner, admin, auditor). Most users have none.",
          },
          {
            name: "User type",
            description:
              'The kind of account, e.g. employee (blue), customer or partner. The root account shows "System account" because it has no type.',
          },
          { name: "Groups (hidden)", description: "IDs of the groups the user belongs to." },
          {
            name: "User ID (hidden)",
            description:
              "The long, permanent account ID (UUID) that applications receive. Use it to match entries in the audit logs.",
          },
        ],
        tips: [
          'Do not confuse the "User ID" (a long system-generated ID such as 0192f6c3-…) with the "User code" (a short code issued by the organization, e.g. an employee number) or the "Username" (a name the user picks, e.g. somchai.k). Both can be typed instead of an email when signing in.',
        ],
      },
      {
        id: "search",
        heading: "Searching",
        body: [
          'Type in the "Search…" box in the toolbar; the table filters as you type. The search matches the primary email, additional emails, phone numbers, user code, username, name, User ID, employee code and department.',
          'Press ✕ in the box ("Clear search") to show everyone again.',
        ],
        tips: [
          "Part of a word is enough — e.g. type @company.co.th to find everyone with a company email.",
          "Changing the search or filters always takes you back to the first page.",
        ],
      },
      {
        id: "filters",
        heading: "Filtering",
        body: [
          'Press "Filters" in the toolbar to open the filter panel. Each filter row has a "Column", an "Operator" and a "Value". "Add filter" adds a row, the bin icon ("Delete filter") removes one, "Remove all" clears them all.',
          'With several filters, a user must match all of them (And). The number on the "Filters" button shows how many filters are active.',
        ],
        shot: {
          file: "users-filters.png",
          caption: 'The filter panel — here filtering users with status "Active"',
        },
        fieldsTitle: "Columns you can filter",
        fields: [
          { name: "Status", description: 'Choose "Active", "Pending" or "Banned".' },
          {
            name: "MFA",
            description: '"Yes" = only users with MFA · "No" = only users without · "Any" = no filter.',
          },
          {
            name: "Roles",
            description: "Choose a role, e.g. admin, to see who holds it (needs permission to read roles).",
          },
          {
            name: "User type",
            description: "Choose a type, e.g. employee or customer (the root account has no type).",
          },
          {
            name: "Groups",
            description: "Choose a group to see its members (needs permission to read groups).",
          },
        ],
        tips: [
          'Open a column\'s header menu (the three-dot icon in the header) and choose "Filter" to add a filter for that column quickly.',
          "Example: to find administrators without 2FA, filter Roles = admin and MFA = No.",
        ],
      },
      {
        id: "sort",
        heading: "Sorting",
        body: [
          'Click the header of "Identifier" (sorts by email), "Display name" or "Created" to sort; click again to switch between ascending and descending. The header menu also has "Sort ascending", "Sort descending" and "Unsort".',
          'Other columns cannot be sorted. After "Unsort", the table goes back to newest first.',
        ],
      },
      {
        id: "paging",
        heading: "Pages and rows per page",
        body: [
          'Below the table you see the range you are viewing, e.g. "1–25 of 240". Choose "Rows per page" 25, 50 or 100 (remembered in your browser). Use "First page", "Previous page" and "Next page" to move.',
          "There is no jump to the last page — use search or filters to find someone quickly.",
        ],
      },
      {
        id: "layout",
        heading: "Hiding columns, density and table layout",
        body: [
          '"Columns" lists every column: tick to show, untick to hide. It has "Find column", "Show all", "Hide all" and "Reset layout" (back to the original layout).',
          '"Density" sets the row spacing: "Compact", "Standard" or "Comfortable".',
          'A column\'s header menu has "Hide column", "Manage columns", "Pin to left" and "Pin to right" (keeps the column visible when you scroll sideways). Drag the edge of a header to resize a column.',
          "The whole layout (visible columns, widths, pins, density) is remembered in your browser only; it does not affect other people.",
        ],
        shot: {
          file: "users-columns.png",
          caption: 'The "Columns" panel — choose which columns to show',
        },
      },
      {
        id: "export",
        heading: "Exporting to CSV",
        body: [
          'The "Export" toolbar button offers "Download as CSV" — every user matching the current search and filters (all pages, up to 5,000) — and "Download N selected as CSV", shown when you have ticked rows.',
          'Tick the box at the start of a row to select a user, or the box in the header ("Select all rows") to select everyone on the page. CSV files open in Excel or Google Sheets.',
        ],
        shot: {
          file: "users-export-menu.png",
          caption: 'The "Export" menu after selecting two users',
        },
        warnings: [
          "Exported files contain personal data (emails, names, …). Keep them according to your organization's PDPA policy, delete them when no longer needed and never send them over insecure channels.",
        ],
      },
      {
        id: "add",
        heading: "Adding a user",
        body: [
          'Press "Add user" at the right of the toolbar (or the same button in the empty table when there are no users yet). The "Add user" dialog opens.',
        ],
        shot: {
          file: "users-add-dialog.png",
          caption: 'The "Add user" dialog',
        },
        fieldsTitle: "Fields in the Add user dialog",
        fields: [
          {
            name: "Email",
            required: true,
            description:
              "The account's primary email: a valid address, at most 254 characters, not used as a primary or additional email by anyone else. Applications receive this email and the invitation is sent to it.",
          },
          {
            name: "Display name",
            required: true,
            description:
              "The name shown in the system and in applications, e.g. Somchai Jaidee. At most 200 characters.",
          },
          {
            name: "User code (optional)",
            description:
              'A short name the user can sign in with instead of the email (e.g. an employee number). 3–32 characters: letters, digits, . _ - starting with a letter or digit. Stored in lower case (PC-00123 → pc-00123). Digits only are fine, but not 9 or more digits (that looks like a phone number). Must not be used by anyone as a user code or username — otherwise "This user code is already taken".',
          },
          {
            name: "Username (optional)",
            description:
              'A second sign-in name the user would like to use (e.g. somchai.k); it works instead of the email just like a user code and follows exactly the same rules. Fill in both fields, one or neither. The same value can never be both a user code and a username (for the same person or two different people) — otherwise "This username is already taken".',
          },
          {
            name: "User type",
            description:
              "Default employee. You can choose another type, e.g. customer or partner. The type decides which applications the account may use and which default groups it gets. Console roles can only be given to employees.",
          },
          {
            name: "Groups",
            description:
              "Pick any number of groups (type to search the list). Shown only if you may change groups. The user type's default groups are always added as well.",
          },
          {
            name: "Roles",
            description:
              'Tick the console roles to give. Shown only if you may change roles and the type is employee (for other types you see "Console roles are available to employees only."). The owner role appears only if you are an owner yourself. Leave empty for most users.',
          },
          {
            name: "Send an invitation email so the user can set a password",
            description:
              "Ticked by default. The user receives an email with a link to choose their own password. The link is valid for 24 hours.",
          },
        ],
        steps: [
          'Press "Add user".',
          'Fill in "Email" and "Display name" (required).',
          'Optionally enter a "User code", such as the employee number, and/or a "Username" the user wants to sign in with.',
          'Choose the "User type" (employee for staff) and any groups.',
          "If this person will administer the system, tick a role such as admin or auditor.",
          'Decide whether to send the invitation, then press "Add user" at the bottom of the dialog (or "Cancel" to close without saving).',
        ],
        tips: [
          "Invalid input is explained under the field, and the dialog stays open so you can correct it.",
        ],
      },
      {
        id: "after-add",
        heading: "After adding a user",
        body: [
          'On success you see "User created" and the new user\'s detail page opens, so you can continue with the profile, phone numbers or other access.',
          'With the invitation: the user gets an email with a link to set a password (valid 24 hours). The status stays "Pending" until they open the link and set the password; then it becomes "Active", because using the emailed link also verifies the email.',
          'Without the invitation: the account has no password yet. The user cannot sign in with a password until you use "Set password" or "Send password reset" on the "Security" tab, or they use "Forgot password" on the sign-in page (or sign in with Google / Microsoft if enabled and the email matches).',
          "Every new user is recorded in the audit logs (user.created).",
        ],
        tips: [
          'If the user did not receive the invitation or the link expired, open the user, go to "Security" and press "Send password reset" (that link is valid for 1 hour), or press "Set password" and give the password to the user privately.',
        ],
        warnings: [
          "If you get an error that the email is already in use, an account already has this email (as its primary or an additional email). Search for it first — do not create duplicates.",
        ],
      },
      {
        id: "reload",
        heading: "Reloading",
        body: [
          'Press the circular-arrow icon ("Reload") next to "Add user" to fetch the latest data, e.g. after another administrator changed a user or a user finished the invitation.',
        ],
      },
    ],
    related: ["user-detail", "groups", "roles", "user-types"],
  },
};

export default topic;
